// export const ISDEV = false;
export const ISDEV = process.env.NODE_ENV === "development";
export const DEFAULT_LOCALE = "ru";

export const locales = [
  { _id: "ru", name: "Русский" },
  { _id: "en", name: "English" },
];

// База REST-API. На стендах подставляется в рантайме контейнера
// (%%API_URL%% в .docker/entrypoint.sh) — один раз на оба бандла.
export const API_URL =
  import.meta.env.VITE_API_URL || "https://api.dev.restomenu.cc/rest/v1";
